<template><Login /></template>
<script>
import Login from './index.vue';
export default { components: { Login } };
</script>
